import * as React from 'react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';

export interface InputContainerWidgetProps {
  label: string;
  className?: any;
  error?: string;
}

export const InputContainerWidget: React.FC<React.PropsWithChildren<InputContainerWidgetProps>> = (props) => {
  return (
    <S.Container className={props.className}>
      <S.Label>{props.label}</S.Label>
      {props.children}
      {props.error ? <S.Error>{props.error}</S.Error> : null}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div``;

  export const Label = styled.div`
    color: ${(p) => p.theme.forms.label};
    padding: 5px;
    font-family: ${Font.Special};
    font-size: 14px;
  `;
  export const Error = styled.div`
    color: ${(p) => p.theme.forms.error};
    padding: 5px;
    font-family: ${Font.Special};
    font-size: 14px;
  `;
}
